// Environment configuration mapping

const ENV_CONFIG = {
  'https://accounts-dev.pixl.ai': {
    productId: '5a31dd5b-2b08-4002-9e75-f7fbc7718d9d',
    planId: 'e390a149-1f53-47dd-9efd-9f5cd07a9299',
    clientApiBaseUrl: 'https://appdemo.pixl.ai/doc-api/Client',
  },
  'https://accounts-uat.pixl.ai': {
    productId: '4ff56ce2-db6a-4029-a2e4-ff31923bf7a0',
    planId: '39e19876-df97-4297-bb03-aa7023075117',
    clientApiBaseUrl: 'https://appdemo.pixl.ai/doc-api/Client',
  },
  'https://accounts.pixl.ai': {
    productId: '00f000fd-a623-4b1c-a727-309867020344',
    planId: 'd444ce99-fee8-44a1-af07-4d997d7b270c',
    clientApiBaseUrl: 'https://appv2.pixl.ai/doc-api/Client',
  },
};

// pcs new production planid is not currently available, once it's available i can update.

function getCurrentConfig() {
  const baseUrl = window.baseUrl;
  const config = ENV_CONFIG[baseUrl];

  if (!config) {
    console.warn(`No configuration found for baseUrl: ${baseUrl}`);
    return ENV_CONFIG['https://accounts-dev.pixl.ai'];
  }

  return config;
}

const {
  productId: PRODUCT_ID,
  planId: PLAN_ID,
  clientApiBaseUrl: clientAPIBaseUrl,
} = getCurrentConfig();

export const API_ENDPOINTS = {
  REFRESH_CREDIT: `${clientAPIBaseUrl}/refreshcredits`,
};

export { PRODUCT_ID, PLAN_ID, clientAPIBaseUrl };

export const HARDCODED_PRODUCT_ID = getCurrentConfig().productId;
export const HARDCODED_PLAN_ID = getCurrentConfig().planId;
export const REFRESH_CREDIT_URL_API = getCurrentConfig().clientAPIBaseUrl;

export const HARDCODED_PRODUCTKEY = 'PCS001';
export const PRODUCT_PLATFORM = {
  PCS_PLATFORM: 'PCS',
  SAAS_PLATFORM: 'SAAS',
}

export const MAINTENANCE_MESSAGES = {
  REGISTERED_USER: "⚠️ As part of ongoing system enhancements, the application is currently undergoing maintenance activities. Some services may be temporarily unavailable. Thank you for your understanding.",
  UNREGISTERED_USER: "Due to increased system demand, registration is temporarily unavailable. Services will resume shortly. Please contact connect@pixl.ai for any support or enquiries."
};
